import { render } from "./ButtonClose.vue?vue&type=template&id=13926f5c&scoped=true&ts=true"
import script from "./ButtonClose.vue?vue&type=script&lang=ts"
export * from "./ButtonClose.vue?vue&type=script&lang=ts"

import "./ButtonClose.vue?vue&type=style&index=0&id=13926f5c&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13926f5c"]])

export default __exports__